<template>
<div class="filter-info" v-if="list.length > 0">
  <div class="filter-info-title">{{ titleText }}</div>
  <!-- {{ previewList }} -->
  <div class="filter-value-list">
    <div
      v-for="(item, index) in previewList"
      :key="item[valKey]"
      :class="item[actKey] ? 'filter-value filter-value-act' : 'filter-value'"
      @click="handleFilterValueClick(item, index)"
    >
      {{ item[nameKey] }}
    </div>
  </div>

  <template v-if="list.length > 4">
    <div
      v-show="!showMore"
      class="show-more"
      @click="handleMoreClick(true)" 
    >
      View More&nbsp;<van-icon name="arrow-down" />
    </div>
    <div
      v-show="showMore"
      class="show-more"
      @click="handleMoreClick(false)"
    >
      View Less&nbsp;<van-icon name="arrow-up" />
    </div>
  </template>
</div>
</template>

<script lang="ts" setup>

interface IProps {
  titleText: string,
  list: any[],
  actKey?: string,
  nameKey?: string,
  valKey?: string
}
const props = withDefaults(
  defineProps<IProps>(),
  {
    nameKey: 'name',
    valKey: 'id',
    actKey: 'select'
  }
)

const showMore = ref<boolean>(false)

const previewList = computed<any[]>(() => 
  props
    .list?.slice(
      0,
      showMore.value ? props.list.length : 4
    )
  )
const emits = defineEmits<{
  (event: 'filter:click', item: any, index: number): void
}>()

const handleFilterValueClick = (item: any, index: number) => {
  emits('filter:click', item, index)
}

const handleMoreClick = (val: boolean) => {
  showMore.value = val
}
</script>

<style lang="scss" scoped>
$padding: 30px;
.filter-info{
  .filter-info-title{
    font-weight: 600;
    font-size: 32px;
    color: #666;
    padding: 0 $padding;
    margin: 10px 0;
  }
  .filter-value-list{
    .filter-value{
      line-height: 60px;
      font-size: 26px;
      padding: 0 $padding;
      cursor: pointer;
      border-left: 4px solid transparent;
      transition: all .15s;
      &:hover{
        color: var(--pc-default-color);
        background-color: rgba($color: #DD3131, $alpha: 0.2);
      }
    }
    .filter-value-act{
      color: var(--pc-default-color);
      background-color: rgba($color: #DD3131, $alpha: 0.2);
      border-color: var(--pc-default-color);
    }
  }
  .filter-price-box{
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 20px;
    padding: 0 30px;
    span{
      color: #cacaca;
      margin: 0 10px;
    }
  }
  .filter-price-box:deep(.van-field){
    border: 1px solid #cacaca;
    padding: 5px 20px;
    width: 160px;
  }
  .filter-price-box:deep(.van-button--normal){
    height: 62px;
    margin-left: 20px;
  }
}
.show-more{
  text-align: center;
  color: var(--pc-default-color);
  padding: 20px;
  font-size: 26px;
  cursor: pointer;
  transition: all .15s;
  &:hover{
    background: rgba($color: #DD3131, $alpha: 0.2);
  }
}
</style>